import PropTypes from 'prop-types';

export const DiscountCodeSubCategoryPropType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  discountCodeCategoryId: PropTypes.number,
  active: PropTypes.bool,
  createDate: PropTypes.number,
});

export const DiscountCodeCategoryPropType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  description: PropTypes.string,
  active: PropTypes.bool,
  createDate: PropTypes.number,
  discountCodeSubCategoryList: PropTypes.arrayOf(
    DiscountCodeSubCategoryPropType,
  ),
});
